import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReportHtml } from 'tms-lib';
import { SupplementaryInvoiceHeader } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SupplementaryInvoiceService extends TmsWebBaseEditCreateService<
  SupplementaryInvoiceHeader,
  SupplementaryInvoiceHeader
> {
  constructor() {
    super('SupplementaryInvoice', $localize`Supplementary Invoice`);
  }

  // Exchange rate for a currency at the document date (auto-fills the header Exchange Rate).
  getExchangeRate(currencyId: string, documentDate: Date | string): Observable<number> {
    const isoDate = new Date(documentDate).toISOString();
    return this.httpService.get<number>(
      `${this.apiUrl}/GetExchangeRate?currencyId=${currencyId}&documentDate=${isoDate}`,
    );
  }

  // Supplementary invoice document print - returns the API-generated HTML (unwrapped for the in-app
  // preview; the report toolbar handles printing via window.print).
  getSupplementaryInvoiceReportHtml(id: string, includeStyles: boolean): Observable<string> {
    return this.httpService
      .get<ReportHtml>(`${this.apiUrl}/SupplementaryInvoiceReportHtml/${id}?includeStyles=${includeStyles}`)
      .pipe(map((model: ReportHtml) => model.html));
  }
}
